import React from 'react';

const QuickSearchLinkItem = ({ name, url }) => {
  return (
    <a className="text-md lowercase first-letter:uppercase" href={url}>
      {name}
    </a>
  );
};

export default QuickSearchLinkItem;
